import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const Header = () => {
  const { t, lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const links = [
    { href: "#services", label: t("nav.services"), id: "services" },
    { href: "#gallery", label: t("nav.gallery"), id: "gallery" },
    { href: "#about", label: t("nav.about"), id: "about" },
    { href: "#contact", label: t("nav.contact"), id: "contact" },
  ];

  const isHome = location.pathname === "/";

  const handleNav = (e, id) => {
    if (isHome) {
      e.preventDefault();
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      setOpen(false);
    }
  };

  return (
    <header
      data-testid="site-header"
      className="backdrop-blur-2xl bg-[#0A0A0C]/70 border-b border-white/10 sticky top-0 z-50"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <img src={`/logo.png?v=5`} alt="İstanbul Organizasyon" className="h-12 md:h-14 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.id}
              href={isHome ? l.href : `/${l.href}`}
              onClick={(e) => handleNav(e, l.id)}
              data-testid={`nav-${l.id}`}
              className="text-sm tracking-[0.2em] uppercase text-white/70 hover:text-[#D4AF37] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-6">
          <div className="flex items-center gap-2 text-xs tracking-widest">
            <button
              data-testid="lang-switch-tr"
              onClick={() => setLang("tr")}
              className={`uppercase transition-colors ${
                lang === "tr" ? "text-[#D4AF37]" : "text-white/40 hover:text-white"
              }`}
            >
              TR
            </button>
            <span className="text-white/20">|</span>
            <button
              data-testid="lang-switch-fr"
              onClick={() => setLang("fr")}
              className={`uppercase transition-colors ${
                lang === "fr" ? "text-[#D4AF37]" : "text-white/40 hover:text-white"
              }`}
            >
              FR
            </button>
          </div>
        </div>

        <button
          data-testid="menu-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#0A0A0C]" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.id}
                href={isHome ? l.href : `/${l.href}`}
                onClick={(e) => handleNav(e, l.id)}
                className="text-sm tracking-[0.2em] uppercase text-white/70 hover:text-[#D4AF37]"
              >
                {l.label}
              </a>
            ))}
            <div className="flex items-center gap-3 pt-3 border-t border-white/10">
              <button
                onClick={() => setLang("tr")}
                className={`uppercase text-xs tracking-widest ${
                  lang === "tr" ? "text-[#D4AF37]" : "text-white/50"
                }`}
              >
                TR
              </button>
              <span className="text-white/20">|</span>
              <button
                onClick={() => setLang("fr")}
                className={`uppercase text-xs tracking-widest ${
                  lang === "fr" ? "text-[#D4AF37]" : "text-white/50"
                }`}
              >
                FR
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
